import React, { Component } from 'react'
import { Link } from 'react-router';
import { translate } from "react-translate"

@translate("NoMatch")
export default class NoMatch extends Component {
  render () {
    let t = this.props.t;
    return (
      <div className="no-match-container">
        <div className="nomatch-404">404</div>
        <div className="no-encontrada">{t("NoEncontrado")}</div>
        <div className="lo-sentimos">{t("LoSentimos")}</div>
        <div className="volver">
          <Link to="/">
            <div className="button flex-item">
              {t("Volver")}
            </div>
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NoMatch/index.js